
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/society-profile/onboarding",
      function () {
        return require("private-next-pages/society-profile/onboarding/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/society-profile/onboarding"])
      });
    }
  